import { Component, OnInit, Output, EventEmitter, Inject, Input } from '@angular/core';
import { TraduccionesComponent } from '../../../../Alsa-MA-Angular-utils/src/app/traducciones.component';
import { Http, RequestOptions, Headers, Response } from '@angular/http';
import { ShowCardsComponent } from '../show-cards/show-cards.component';

declare var i18nVS: any;
declare var movimientosTarjeta: any;
declare var studentDesktopNamespace: any;

@Component({
  selector: 'app-show-movimientos',
  templateUrl: './show-movimientos.component.html',
  styleUrls: ['./show-movimientos.component.css']
})
export class ShowMovimientosComponent implements OnInit {
    
    @Input() numtarjetaSeleccionada: string;
    @Output () showMovimientos: EventEmitter<any> = new EventEmitter<any>();    // permite indicar que este componente se deje de visualizar
    @Output() onWebServiceError: EventEmitter<boolean> = new EventEmitter<boolean>();
    
    // propiedades
    i18nL = TraduccionesComponent.arrayTraducciones;
    namespacePortlet = studentDesktopNamespace;
    
    mostrarMovimientos = false;
    movimientos = null;
    jsonData;   // contendra los datos recibidos por el ResourceCommand que proporciona las tarjetas del usuario
    listaMovimientos;
    numeroTarjeta = null;
    fechaFrom = null;
    fechaTo = null;
    today;
    outOfRange = false;
    outOfRangeTable = false;
    aviso = false;
    spinnerClass = "";
    spinnerStart = "";
    noMovimientos = false;
    
    
    // metodos
    private setTraslater(){
        if (typeof i18nVS !== 'undefined') { // Para saber si Liferay esta disponible o no
            this.i18nL = i18nVS;
        }
    }
    
    // indica que la plantilla de este componente ya no debe mostrarse
    public cerrarShowMovimientos () {
        this.showMovimientos.emit(this.mostrarMovimientos);
    }
    
    // llamada al ResourceCommand
    public getTransacciones () {
        console.log("Inicio del metodo 'getTransacciones' del componente 'ShowMovimientosComponent'");
                
        var llamadaWS = (movimientosTarjeta
                         + "&" + this.namespacePortlet + "cardNum=" + this.numtarjetaSeleccionada.toString()
                         + "&" + this.namespacePortlet + "fechaDesde=" + this.formatoFecha(this.fechaFrom).toString()
                         + "&" + this.namespacePortlet + "fechaHasta=" + this.formatoFecha(this.fechaTo).toString()
                        ).toString();
        
        console.log("Se realizara la siguiente llamada: " + llamadaWS);
        
        this.ajaxReq.get(llamadaWS, new Map<string, string>()).subscribe(
                    res => { this.validateJSON(res, llamadaWS) },
                    (err) => this.errorEnElJson(err, llamadaWS),
                    () => this.movimientosDeTarjetas()
                );
        
        console.log("Fin del metodo 'getTransacciones' del componente 'ShowMovimientosComponent'");
    }
    
    /**
     * valida objetos JSON
     * @param res recurso a validar
     */
    private validateJSON (res: Response, url: string) {
        try {
            // se recogen los datos del servicio invocado (los movimientos de la tarjeta seleccionada)
            this.jsonData = res.json();
            
            // oculta el spinner
            this.spinnerClass = 'invisible';
            this.spinnerStart = '';
            
            // si no hay movimientos en la tarjeta seleccionada lo indica
            if (this.jsonData == null || this.jsonData == '' || this.jsonData == undefined) {
            	this.noMovimientos = true;
            } else {
                // si tras "ver" que no hay movimientos en una tarjeta se quiere ver los movimientos
                // de otra, el aviso de "no hay movimientos" no debe mostrarse
                this.noMovimientos = false;
            }
        } catch (error) {
            console.log(res);
            this.errorEnElJson("Error parseando el json", url);
        }
    }
    
    /**
     * Procesa errores detectados en el formato JSON
     */
    private errorEnElJson(err: string, url: string){
        console.log('Error en la llamada: ' + err);
        console.log(url);
        this.onWebServiceError.emit(true);
    }
    
    // recupera los datos del servicio para manipularlos
    public movimientosDeTarjetas() {
        // se verifica si la tabla ha sido ocultada (en este caso se esta viendo los movimientos de
        // una tarjeta distinta a la actual por lo que se recuperan los nuevos datos y se visualiza
        // la tabla en la que se imprimiran)
        var movimientosTabla = (<HTMLDivElement>document.getElementById('tablaMovimientosTarjeta'));
        
        if (movimientosTabla.style.display == 'none') {    // se ha ocultado la tabla previamente
            movimientosTabla.style.display = 'block';
        }
        
        this.listaMovimientos = this.jsonData;
    }
    
    // comprobacion de cantidad de dias del rango establecido, si el rango es mayor a 30 dias se indica que no es correcto
    public validacionRango() {
        var dias = this.checkDateRange();
        if (dias != null) {
            if (dias >= 365) {
                this.outOfRange = true;
                this.outOfRangeTable = !this.outOfRange;
                
                this.listaMovimientos = null;
            } else {
                this.outOfRange = false;
            }
        }
    }
    
    // calculo de la cantidad de dias del rango establecido
    public checkDateRange () {
        var days = null;
        
        this.fechaTo = (<HTMLSelectElement>document.getElementById(this.namespacePortlet + 'to')).value;
        this.fechaFrom = (<HTMLSelectElement>document.getElementById(this.namespacePortlet + 'from')).value;
        
        if (this.fechaFrom != null && this.fechaTo != null) {
            days = parseInt((((new Date(this.fechaTo)).getTime() - (new Date(this.fechaFrom)).getTime()) / (24 * 3600 * 1000)).toString());
        } else {
            days = null;
        }
        
        return days;
    }
    
    // formatea la fecha actual para establecerla por defecto
    public formatoFechaActual () {
        var now = new Date();
        
        var currentDay;
        var currentMonth;
        
        currentMonth = now.getMonth();
        
        if ((parseInt(currentMonth.toString()) + 1) < 10) {
            currentMonth = "0" + (parseInt(currentMonth) + 1);
        }else{
            currentMonth=""+(parseInt(currentMonth) + 1);
        }
        
        currentDay = now.getDate();
        
        if (parseInt(currentDay.toString()) < 10) {
            currentDay = "0" + parseInt(currentDay);
        }

        // formateo de la fecha actual para establecer la fecha por defecto
        this.today = now.getFullYear() + "-" + currentMonth + "-" + currentDay;        
    }
    
    // formato fehca generica
    public formatoFecha (fecha) {
        var parametroFecha = new Date(fecha);
        
        var currentDay;
        var currentMonth;
        
        currentMonth = parametroFecha.getMonth();
        
        if ((parseInt(currentMonth.toString()) + 1) < 10) {
            currentMonth = "0" + (parseInt(currentMonth) + 1);
        }else{
            currentMonth=""+(parseInt(currentMonth) + 1);
        }
        
        currentDay = parametroFecha.getDate();
        
        if (parseInt(currentDay.toString()) < 10) {
            currentDay = "0" + parseInt(currentDay);
        }

        return (parametroFecha.getFullYear() + "-" + currentMonth + "-" + currentDay);        
    }
    
    // realiza la llamada al servicio
    public llamarServicio() {
        // desde que se invoca al servicio hasta que se carguen los datos se muestra
        // el spinner
        this.spinnerStart = 'spinner';
        this.spinnerClass = '';
        
        // si hay una tarjeta seleccionada no se muestra el aviso de que debe
        // seleccionar una tarjeta
        if (this.numtarjetaSeleccionada != undefined) {
            this.aviso = false;
            
            // si las fechas seleccioandas estan en el rango correcto se hace la
            // llamada al servicio
            if (!this.outOfRange) {
                this.getTransacciones();
                
                this.outOfRangeTable = !this.outOfRange;
            }
        } else {
        	this.aviso = true;
        }
    }    
    
    
    
    constructor(@Inject(Http) private ajaxReq) { }
    
    ngOnInit() {
        this.setTraslater();
        this.formatoFechaActual();
    }
}



// WEBPACK FOOTER //
// ./src/app/show-movimientos/show-movimientos.component.ts